import { useSuspenseQuery } from '@apollo/client/react';
import { Row, Space } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatSettings, ChatAPI } from '@guuru/chat-web';
import ChatNPSRate from './ChatNPSRate';
import GET_CHAT from './queries/GetUserEmailAndShouldBeContacted';
import { GoBackLink, Headline, Text } from './style';

const ChatThanks = function ({ chatId, readOnly = false }) {
  const { t } = useTranslation();
  const locale = ChatAPI.storeRetrieveLocale();

  const {
    data: {
      chatSettings: {
        name: partnerName,
        thankYouSectionShowNps,
        thankYouSectionLink,
      } = {},
    } = {},
  } = useChatSettings();

  const { data: { chat: { shouldBeContacted, user } = {} } = {} } =
    useSuspenseQuery(GET_CHAT, { variables: { id: chatId } });

  const i18nData = {
    partnerName,
    email: user?.email,
  };

  const showActionLink = thankYouSectionLink?.[locale];
  const showNPSSection = !!thankYouSectionShowNps;
  return (
    <Row justify="center">
      <Space orientation="vertical">
        <Headline>{t('chat:::finishedThankYouHeadline', i18nData)}</Headline>
        {shouldBeContacted && (
          <Text>{t('chat:::rateExpertBadEndContact', i18nData)}</Text>
        )}
        {showActionLink && (
          <GoBackLink href={thankYouSectionLink[locale]} target="_blank">
            {t('chat:::finishedGoBackToPartner', i18nData)}
          </GoBackLink>
        )}
        {!readOnly && showNPSSection && chatId && (
          <ChatNPSRate chatId={chatId} />
        )}
      </Space>
    </Row>
  );
};

ChatThanks.propTypes = {
  chatId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
};

export default React.memo(ChatThanks);
